import {
    CHANGE_FONT_SIZE,
    SET_GAME_SETTINGS,
    TOGGLE_AUDIO,
    TOGGLE_TIMED_GAMES,
} from '../constants/actions';

const defaultRouter = {
    gameSettings: {
        difficulty: null,
        party: null,
        importantIssue: null,
        failThreshold: -30,
    },
    accessibility: {
        fontSize: 'medium',
        timedGames: true,
    },
    audio: true,
};

export const settings = (state = defaultRouter, action) => {
    switch (action.type) {
        case SET_GAME_SETTINGS:
            return {
                ...state,
                gameSettings: action.gameSettings,
            };
        case CHANGE_FONT_SIZE:
            return {
                ...state,
                accessibility: {
                    ...state.accessibility,
                    fontSize: action.fontSize,
                },
            };
        case TOGGLE_AUDIO:
            return {
                ...state,
                audio: action.boolean,
            };
        case TOGGLE_TIMED_GAMES:
            return {
                ...state,
                accessibility: {
                    ...state.accessibility,
                    timedGames: action.boolean,
                },
            };
        default:
            return state;
    }
};
